'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
export interface BirthdayAppealAmountOption {
  value: string;
  label?: string;
}
export interface UseBirthdayAppealArgs {
  amountOptions: BirthdayAppealAmountOption[];
  defaultAmount?: string;
  onAdd: (amount: string) => void;
  onAmountChange?: (amount: string) => void;
}
export interface UseBirthdayAppealResult {
  selectedAmount: string;
  handleAmountChange: (amount: string) => void;
  handleAdd: () => void;
}
export const useBirthdayAppeal = t0 => {
  const $ = _c(9);
  const {
    amountOptions,
    defaultAmount,
    onAdd,
    onAmountChange
  } = t0;
  const [selectedAmount, setSelectedAmount] = useState(defaultAmount ?? amountOptions[0]?.value ?? "");
  let t1;
  if ($[0] !== onAmountChange) {
    t1 = amount => {
      setSelectedAmount(amount);
      onAmountChange?.(amount);
    };
    $[0] = onAmountChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleAmountChange = t1;
  let t2;
  if ($[2] !== onAdd || $[3] !== selectedAmount) {
    t2 = () => {
      onAdd(selectedAmount);
    };
    $[2] = onAdd;
    $[3] = selectedAmount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleAdd = t2;
  let t3;
  if ($[5] !== handleAdd || $[6] !== handleAmountChange || $[7] !== selectedAmount) {
    t3 = {
      selectedAmount,
      handleAmountChange,
      handleAdd
    };
    $[5] = handleAdd;
    $[6] = handleAmountChange;
    $[7] = selectedAmount;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};